import styles from './AppForm.module.scss';
import classNames from 'classnames';
import Switch from '@mui/material/Switch';

//param @app : AppManagementModel
//param @setApp : function
const AppMasterForm = ({ app, setApp, validationErrors }) => {
	const handleChange = e => {
		setApp({
			...app,
			appMaster: {
				...app.appMaster,
				[e.target.name]: e.target.value,
			},
		});
	};

	const handleBoolToggle = e => {
		setApp({
			...app,
			appMaster: {
				...app.appMaster,
				[e.target.name]: !app.appMaster[e.target.name],
			},
		});
	};

	//resolve error message cause by null value on inputs
	const resolveTextAreaNull = value => {
		if (value === null) {
			return '';
		} else return value;
	};
	const resolveBoolNull = value => {
		if (value === null || value === undefined) {
			return false;
		} else return value;
	};

	return (
		<div className={styles.formContainer}>
			{/* name : string(64)*/}
			<div className={styles.detailLabel}>
				<p>
					Application Name{' '}
					<span className={styles.characterCount}>
						(
						{app?.appMaster?.name?.length
							? app?.appMaster?.name?.length
							: 0}
						/{64})
					</span>
				</p>
				<input
					name='name'
					onChange={e => handleChange(e)}
					value={resolveTextAreaNull(app.appMaster.name)}
					maxLength={64}
				/>
				{/*appMaster.name validation error*/}
				<p className={styles.error}>
					{
						validationErrors.find(error => error.field === 'name')
							?.message
					}
				</p>
			</div>
			{/* description : string(255) */}
			<div className={styles.detailLabel}>
				<p>
					Description{' '}
					<span className={styles.characterCount}>
						(
						{app?.appMaster?.description?.length
							? app?.appMaster?.description?.length
							: 0}
						/{255})
					</span>
				</p>
				<textarea
					className={classNames([styles.detailInfo, styles.textArea])}
					type='text'
					value={resolveTextAreaNull(app.appMaster.description)}
					onChange={e => handleChange(e)}
					name='description'
					maxLength={255}
					rows={5}
				/>
			</div>
			{/* patientData : bool */}
			<p>Contains Patient Data </p>
			<Switch
				checked={resolveBoolNull(app?.appMaster?.patientData)}
				name='patientData'
				onClick={e => handleBoolToggle(e)}
			/>
			{/* sentillionFlag : bool */}
			<p>Sentillion Flag</p>
			<Switch
				checked={resolveBoolNull(app?.appMaster?.sentillionFlag)}
				name='sentillionFlag'
				onClick={e => handleBoolToggle(e)}
			/>
			{/* validationKey : string(16) - hidden if sentillionFlag==false*/}
			{app?.appMaster?.sentillionFlag === true ? (
				<div className={styles.detailLabel}>
					<p>
						Validation Key{' '}
						<span className={styles.characterCount}>
							(
							{app?.appMaster?.validationKey?.length
								? app?.appMaster?.validationKey?.length
								: 0}
							/{16})
						</span>
					</p>
					<input
						name='validationKey'
						onChange={e => handleChange(e)}
						value={resolveTextAreaNull(app.appMaster.validationKey)}
						maxLength={16}
					/>
				</div>
			) : null}
		</div>
	);
};

export default AppMasterForm;
